import { LatLng } from 'leaflet';
import { db } from '../DBUtils';
import { ITrail } from '../interfaces/ITrail';
import { PlaceList, PlaceQuery } from './PlaceFactory';
import { ITaxonomy } from '../interfaces/ITaxonomy';

export type TopicList = {
	topics: ITaxonomy[];
	success: boolean;
	reason?: string;
};

export class TopicFactory {
	public static getEmpty() {
		const empty_set: TopicList = {
			topics: [],
			success: true,
		};
		return empty_set;
	}

	public static async getAll() {
		return db.topics
			.toArray()
			.then(async (my_topics) => {
				let retval: TopicList = {
					topics: my_topics,
					success: true,
				};
				return retval;
			})
			.catch((reason) => {
				let retval: TopicList = {
					topics: [],
					success: false,
					reason: reason,
				};
				return retval;
			});
	}
}
